// src/components/ClientGrid.jsx
import React from 'react'

export default function ClientGrid({ clients }) {
  if (!clients || clients.length === 0) {
    return <p className="mx-[5%] md:mx-[10%] mt-6 text-sm text-gray-500">No clients to show.</p>
  }

  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-4 w-[90%] md:w-[80%] 2xl:w-[70%] my-6 mb-20 mx-auto">
      {clients.map((c, i) => (
        <div key={`${c.name}-${i}`} data-aos="fade-up" className="flex items-center justify-center p-2">
          <img
            src={c.img}
            alt={`${c.name} logo`}
            className="object-contain border-[1px] hover:scale-110 duration-300 h-[80px] md:h-[100px] 2xl:h-[140px] w-full p-2 bg-white"
            onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = '/images/no_data.png' }}
          />
        </div>
      ))}
    </div>
  )
}
